import { Divider, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { color } from "../../../../StyleData/Config";
import { useSelector } from "react-redux";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";

const General = ({ data }) => {

  const [stockData,setStockData]=useState([])
  const [eoq, setEoq] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const[reorderPoint, setReOrderPoint] = useState([]);
      console.log(eoq);
  useEffect(() => {
    getData();
  }, []);

  const getData = async() => {
    setIsLoading(true);
    const link = masterAPI["inventory"].getSaftStockLevel;
   await axiosPrivate
      .get(`${link}/${data.partId}`)
      .then((res) => {
        console.log(res.data.result.safetyStockLevelValue, "stock level result");
        setStockData(res.data.result.safetyStockLevelValue);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "stocklevel");
        setStockData([])
        setIsLoading(false);
      });
       const linkre = masterAPI["inventory"].getReOrderPoint;
   await axiosPrivate
      .get(`${linkre}/${data.partId}`)
      .then((res) => {
        console.log(res.data.result.reOrderPointValue, "re order result");
        setReOrderPoint(res.data.result.reOrderPointValue);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "re order");
        setReOrderPoint([])
        setIsLoading(false);
      });
       const linkeoq = masterAPI["inventory"].getEOQValue;
       await axiosPrivate
      .get(`${linkeoq}/${data.partId}`)
      .then((res) => {
        console.log(res.data.result.economicReOrderQuantityValue, "economicReOrderQuantityValue result");
        setEoq(res.data.result.economicReOrderQuantityValue);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "setEoq");
        setEoq([])
        setIsLoading(false);
      });
  };


const siteInfoDetail=useSelector(state=>state.auth.loginInfo)
  return (
    
    <Grid container spacing={"1rem"}>
      <Grid item xs={12} md={6}>
        <Paper sx={{ width: "100%", p: 1.5,height:"100%" }}>
        <Grid container spacing={"0.5rem"}>
            <Grid item xs={12} >
                <Typography
                  sx={{
                    color: color.masterDialogTitleColor,
                    fontSize: color.masterDialogFontSize,
                    fontWeight: color.sideWeightFont,
                    mb: "10px",
                  }}
                >
                 Basic
                </Typography>
                <Divider
                  sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Part Code
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {data.code}
                  </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Part Name
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {data.partName}
                  </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                   Stockroom Code
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {data.stockRoomCode}
                  </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                   Stockroom Name
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {data.stockRoomName}
                  </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                   Stock Category
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {data.stockcategory}
                  </Typography>
            </Grid>
        </Grid>
        </Paper>
      </Grid>
      <Grid item xs={12} md={6}>
        <Paper sx={{ width: "100%", p: 1.5,height:"100%" }}>
        <Grid container spacing={"0.5rem"}>
            <Grid item xs={12} >
                <Typography
                  sx={{
                    color: color.masterDialogTitleColor,
                    fontSize: color.masterDialogFontSize,
                    fontWeight: color.sideWeightFont,
                    mb: "10px",
                  }}
                >
                 Reorder
                </Typography>
                <Divider
                  sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Safety Stock Level
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
           {Array.isArray(stockData) && stockData.length === 0 ? 0 : stockData}
                  </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Economic Reorder Quantity
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                      {eoq == undefined ? 0 : eoq}
    
                  </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                   Reorder Point
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {Array.isArray(reorderPoint) && reorderPoint.length === 0 ? 0 : reorderPoint}
 
                  </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                   Max Quantity
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {data.maxQuantity}
                  </Typography>
            </Grid>

            </Grid>
        </Paper>
      </Grid>
      <Grid item xs={12} md={6}>
        <Paper sx={{ width: "100%", p: 1.5,height:"100%" }}>
        <Grid container spacing={"0.5rem"}>
            <Grid item xs={12} >
                <Typography
                  sx={{
                    color: color.masterDialogTitleColor,
                    fontSize: color.masterDialogFontSize,
                    fontWeight: color.sideWeightFont,
                    mb: "10px",
                  }}
                >
                 Balance Summary
                </Typography>
                <Divider
                  sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Qty on hand
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {data.balanceQuantity}
                  </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Last Count Date
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {/* {data.economicReOrderQuantity} */}
                    ----
                  </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Reserved Quantity
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {data.reservedQtyInRoom}
                  </Typography>
            </Grid>
             <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Total Quantity
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {data.totalQuantity}
                  </Typography>
            </Grid>
            </Grid>
        </Paper>
      </Grid>
      <Grid item xs={12} md={6}>
        <Paper sx={{ width: "100%", p: 1.5,height:"100%" }}>
        <Grid container spacing={"0.5rem"}>
            <Grid item xs={12} >
                <Typography
                  sx={{
                    color: color.masterDialogTitleColor,
                    fontSize: color.masterDialogFontSize,
                    fontWeight: color.sideWeightFont,
                    mb: "10px",
                  }}
                >
                 Inventory Cost
                </Typography>
                <Divider
                  sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                   Standard Price
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {siteInfoDetail.currencySymbol}{data.standardPrice}
                  </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Average Price
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {siteInfoDetail.currencySymbol}{data.averagePrice}
                  </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Last Receipt Price
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: color.TabDatafontsize,
                      mb: color.TabDatamarginbottom,
                    }}
                  >
                    {siteInfoDetail.currencySymbol}{data.lastReceiptPrice}
                  </Typography>
            </Grid>
            </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default General;
